// extracted by mini-css-extract-plugin
module.exports = {"cont-doctor-card":"cont-doctor-card","contDoctorCard":"cont-doctor-card"};